import { DescriptionOutlined } from '@mui/icons-material';
import DownloadIcon from '@mui/icons-material/Download';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import { Menu, MenuItem, Typography } from '@mui/material';
import { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useFetchExportFile } from '@/api/queries/useExportFile';
import { useScriptTransferVisible } from '@/components/ImportScript/ImportScript';
import { Text } from '@/components/ui/text';
import { Tooltip } from '@/components/ui/tooltip';
import { FileExtension } from '@/enums';
import { useProjectId } from '@/hooks';
import { usePrefValue } from '@/preferences';
import { ExportButton } from './ExportScript.styles';

export const ExportScript = () => {
    const { t } = useTranslation();
    const side_bar = usePrefValue('side_bar');
    const projectId = useProjectId();
    const exportFile = useFetchExportFile();
    const [menuOpen, setMenuOpen] = useState(false);
    const anchorRef = useRef<HTMLDivElement>(null);
    const visible = useScriptTransferVisible();

    if (!visible || !projectId) return null;

    const disabled = exportFile.isPending;

    const handleExport = (outlineOnly: boolean) => {
        exportFile.mutate({ project_id: projectId, type: 'outline', format: FileExtension.pdf, outlineOnly });
        setMenuOpen(false);
    };

    return (
        <>
            <ExportButton ref={anchorRef} sideBar={side_bar} disabled={disabled} onClick={() => !disabled && setMenuOpen(true)}>
                {side_bar ? (
                    <>
                        <DownloadIcon fontSize="small" />
                        <Text variant="body2" color="text-inherit" children={t('synopsis-page.export-script')} />
                    </>
                ) : (
                    <Tooltip
                        title={<Typography variant="body2" color={theme => theme.custom.c22} children={t('synopsis-page.export-script')} />}
                        disableInteractive
                        placement="left"
                        sideOffset={8}
                        contentClassName="py-2 pr-3 pl-0 bg-bg-paper"
                    >
                        <div className="flex">
                            <DownloadIcon fontSize="small" />
                        </div>
                    </Tooltip>
                )}
            </ExportButton>
            <Menu
                anchorEl={anchorRef.current}
                open={menuOpen}
                onClose={() => setMenuOpen(false)}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                transformOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                slotProps={{ paper: { className: 'bg-bg-paper' } }}
            >
                <MenuItem onClick={() => handleExport(false)}>
                    <PictureAsPdfIcon fontSize="small" className="mr-2" />
                    <Text variant="body1" color="text-text-primary">
                        {t('export_full_script')}
                    </Text>
                </MenuItem>
                <MenuItem onClick={() => handleExport(true)}>
                    <DescriptionOutlined fontSize="small" className="mr-2" />
                    <Text variant="body1" color="text-text-primary">
                        {t('export_synopsis')}
                    </Text>
                </MenuItem>
            </Menu>
        </>
    );
};
